export const TIMEZONES = [
  {
    value: 'Pacific/Midway',
    label: 'Midway Island, Samoa (Pacific Standard Time)',
  },
  {
    value: 'America/Adak',
    label: 'America/Adak (Hawaii-Aleutian Standard Time)',
  },
  {
    value: 'America/Atka',
    label: 'America/Atka (Hawaii-Aleutian Standard Time)',
  },
  {
    value: 'Pacific/Marquesas',
    label: 'Marquesas Islands (Pacific Standard Time)',
  },
  {
    value: 'Pacific/Gambier',
    label: 'Gambier Islands (Pacific Standard Time)',
  },
  {
    value: 'America/Anchorage',
    label: 'America/Anchorage (Alaska Standard Time)',
  },
  {
    value: 'America/Juneau',
    label: 'America/Juneau (Alaska Standard Time)',
  },
  {
    value: 'America/Nome',
    label: 'America/Nome (Alaska Standard Time)',
  },
  {
    value: 'America/Yakutat',
    label: 'America/Yakutat (Alaska Standard Time)',
  },
  {
    value: 'America/Dawson',
    label: 'America/Dawson (Pacific Standard Time)',
  },
  {
    value: 'America/Los_Angeles',
    label: 'America/Los_Angeles (Pacific Standard Time)',
  },
  {
    value: 'America/Tijuana',
    label: 'America/Tijuana (Pacific Standard Time)',
  },
  {
    value: 'America/Vancouver',
    label: 'America/Vancouver (Pacific Standard Time)',
  },
  {
    value: 'America/Whitehorse',
    label: 'America/Whitehorse (Pacific Standard Time)',
  },
  {
    value: 'Canada/Pacific',
    label: 'Canada/Pacific (Pacific Standard Time)',
  },
  {
    value: 'Canada/Yukon',
    label: 'Canada/Yukon (Pacific Standard Time)',
  },
  {
    value: 'Mexico/BajaNorte',
    label: 'Mexico/BajaNorte (Pacific Standard Time)',
  },
  {
    value: 'America/Boise',
    label: 'America/Boise (Mountain Standard Time)',
  },
  {
    value: 'America/Cambridge_Bay',
    label: 'America/Cambridge_Bay (Mountain Standard Time)',
  },
  {
    value: 'America/Chihuahua',
    label: 'America/Chihuahua (Mountain Standard Time)',
  },
  {
    value: 'America/Dawson_Creek',
    label: 'America/Dawson_Creek (Mountain Standard Time)',
  },
  {
    value: 'America/Denver',
    label: 'America/Denver (Mountain Standard Time)',
  },
  {
    value: 'America/Edmonton',
    label: 'America/Edmonton (Mountain Standard Time)',
  },
  {
    value: 'America/Hermosillo',
    label: 'America/Hermosillo (Mountain Standard Time)',
  },
  {
    value: 'America/Inuvik',
    label: 'America/Inuvik (Mountain Standard Time)',
  },
  {
    value: 'America/Mazatlan',
    label: 'America/Mazatlan (Mountain Standard Time)',
  },
  {
    value: 'America/Phoenix',
    label: 'America/Phoenix (Mountain Standard Time)',
  },
  {
    value: 'America/Shiprock',
    label: 'America/Shiprock (Mountain Standard Time)',
  },
  {
    value: 'America/Yellowknife',
    label: 'America/Yellowknife (Mountain Standard Time)',
  },
  {
    value: 'Canada/Mountain',
    label: 'Canada/Mountain (Mountain Standard Time)',
  },
  {
    value: 'Mexico/BajaSur',
    label: 'Mexico/BajaSur (Mountain Standard Time)',
  },
  {
    value: 'America/Belize',
    label: 'America/Belize (Central Standard Time)',
  },
  {
    value: 'America/Cancun',
    label: 'America/Cancun (Central Standard Time)',
  },
  {
    value: 'America/Chicago',
    label: 'America/Chicago (Central Standard Time)',
  },
  {
    value: 'America/Costa_Rica',
    label: 'America/Costa_Rica (Central Standard Time)',
  },
  {
    value: 'America/El_Salvador',
    label: 'America/El_Salvador (Central Standard Time)',
  },
  {
    value: 'America/Guatemala',
    label: 'America/Guatemala (Central Standard Time)',
  },
  {
    value: 'America/Managua',
    label: 'America/Managua (Central Standard Time)',
  },
  {
    value: 'America/Menominee',
    label: 'America/Menominee (Central Standard Time)',
  },
  {
    value: 'America/Merida',
    label: 'America/Merida (Central Standard Time)',
  },
  {
    value: 'America/Mexico_City',
    label: 'America/Mexico_City (Central Standard Time)',
  },
  {
    value: 'America/Monterrey',
    label: 'America/Monterrey (Central Standard Time)',
  },
  {
    value: 'America/Rainy_River',
    label: 'America/Rainy_River (Central Standard Time)',
  },
  {
    value: 'America/Rankin_Inlet',
    label: 'America/Rankin_Inlet (Central Standard Time)',
  },
  {
    value: 'America/Regina',
    label: 'America/Regina (Central Standard Time)',
  },
  {
    value: 'America/Swift_Current',
    label: 'America/Swift_Current (Central Standard Time)',
  },
  {
    value: 'America/Tegucigalpa',
    label: 'America/Tegucigalpa (Central Standard Time)',
  },
  {
    value: 'America/Winnipeg',
    label: 'America/Winnipeg (Central Standard Time)',
  },
  {
    value: 'Canada/Central',
    label: 'Canada/Central (Central Standard Time)',
  },
  {
    value: 'Canada/East-Saskatchewan',
    label: 'Canada/East-Saskatchewan (Central Standard Time)',
  },
  {
    value: 'Canada/Saskatchewan',
    label: 'Canada/Saskatchewan (Central Standard Time)',
  },
  {
    value: 'Chile/EasterIsland',
    label: 'Chile/EasterIsland (Easter Is. Time)',
  },
  {
    value: 'Mexico/General',
    label: 'Mexico/General (Central Standard Time)',
  },
  {
    value: 'America/Bogota',
    label: 'America/Bogota (Colombia Time)',
  },
  {
    value: 'America/Cayman',
    label: 'America/Cayman (Eastern Standard Time)',
  },
  {
    value: 'America/Detroit',
    label: 'America/Detroit (Eastern Standard Time)',
  },
  {
    value: 'America/Grand_Turk',
    label: 'America/Grand_Turk (Eastern Standard Time)',
  },
  {
    value: 'America/Guayaquil',
    label: 'America/Guayaquil (Ecuador Time)',
  },
  {
    value: 'America/Havana',
    label: 'America/Havana (Cuba Standard Time)',
  },
  {
    value: 'America/Indianapolis',
    label: 'America/Indianapolis (Eastern Standard Time)',
  },
  {
    value: 'America/Iqaluit',
    label: 'America/Iqaluit (Eastern Standard Time)',
  },
  {
    value: 'America/Jamaica',
    label: 'America/Jamaica (Eastern Standard Time)',
  },
  {
    value: 'America/Lima',
    label: 'America/Lima (Peru Time)',
  },
  {
    value: 'America/Louisville',
    label: 'America/Louisville (Eastern Standard Time)',
  },
  {
    value: 'America/Montreal',
    label: 'America/Montreal (Eastern Standard Time)',
  },
  {
    value: 'America/Nassau',
    label: 'America/Nassau (Eastern Standard Time)',
  },
  {
    value: 'America/New_York',
    label: 'America/New_York (Eastern Standard Time)',
  },
  {
    value: 'America/Nipigon',
    label: 'America/Nipigon (Eastern Standard Time)',
  },
  {
    value: 'America/Panama',
    label: 'America/Panama (Eastern Standard Time)',
  },
  {
    value: 'America/Pangnirtung',
    label: 'America/Pangnirtung (Eastern Standard Time)',
  },
  {
    value: 'America/Port-au-Prince',
    label: 'America/Port-au-Prince (Eastern Standard Time)',
  },
  {
    value: 'America/Resolute',
    label: 'America/Resolute (Eastern Standard Time)',
  },
  {
    value: 'America/Thunder_Bay',
    label: 'America/Thunder_Bay (Eastern Standard Time)',
  },
  {
    value: 'America/Toronto',
    label: 'America/Toronto (Eastern Standard Time)',
  },
  {
    value: 'Canada/Eastern',
    label: 'Canada/Eastern (Eastern Standard Time)',
  },
  {
    value: 'America/Caracas',
    label: 'America/Caracas (Venezuela Time)',
  },
  {
    value: 'America/Anguilla',
    label: 'America/Anguilla (Atlantic Standard Time)',
  },
  {
    value: 'America/Antigua',
    label: 'America/Antigua (Atlantic Standard Time)',
  },
  {
    value: 'America/Aruba',
    label: 'America/Aruba (Atlantic Standard Time)',
  },
  {
    value: 'America/Asuncion',
    label: 'America/Asuncion (Paraguay Time)',
  },
  {
    value: 'America/Barbados',
    label: 'America/Barbados (Atlantic Standard Time)',
  },
  {
    value: 'America/Blanc-Sablon',
    label: 'America/Blanc-Sablon (Atlantic Standard Time)',
  },
  {
    value: 'America/Boa_Vista',
    label: 'America/Boa_Vista (Amazon Time)',
  },
  {
    value: 'America/Campo_Grande',
    label: 'America/Campo_Grande (Amazon Time)',
  },
  {
    value: 'America/Cuiaba',
    label: 'America/Cuiaba (Amazon Time)',
  },
  {
    value: 'America/Curacao',
    label: 'America/Curacao (Atlantic Standard Time)',
  },
  {
    value: 'America/Dominica',
    label: 'America/Dominica (Atlantic Standard Time)',
  },
  {
    value: 'America/Eirunepe',
    label: 'America/Eirunepe (Amazon Time)',
  },
  {
    value: 'America/Glace_Bay',
    label: 'America/Glace_Bay (Atlantic Standard Time)',
  },
  {
    value: 'America/Goose_Bay',
    label: 'America/Goose_Bay (Atlantic Standard Time)',
  },
  {
    value: 'America/Grenada',
    label: 'America/Grenada (Atlantic Standard Time)',
  },
  {
    value: 'America/Guadeloupe',
    label: 'America/Guadeloupe (Atlantic Standard Time)',
  },
  {
    value: 'America/Guyana',
    label: 'America/Guyana (Guyana Time)',
  },
  {
    value: 'America/Halifax',
    label: 'America/Halifax (Atlantic Standard Time)',
  },
  {
    value: 'America/La_Paz',
    label: 'America/La_Paz (Bolivia Time)',
  },
  {
    value: 'America/Manaus',
    label: 'America/Manaus (Amazon Time)',
  },
  {
    value: 'America/Marigot',
    label: 'America/Marigot (Atlantic Standard Time)',
  },
  {
    value: 'America/Martinique',
    label: 'America/Martinique (Atlantic Standard Time)',
  },
  {
    value: 'America/Moncton',
    label: 'America/Moncton (Atlantic Standard Time)',
  },
  {
    value: 'America/Montserrat',
    label: 'America/Montserrat (Atlantic Standard Time)',
  },
  {
    value: 'America/Port_of_Spain',
    label: 'America/Port_of_Spain (Atlantic Standard Time)',
  },
  {
    value: 'America/Porto_Velho',
    label: 'America/Porto_Velho (Amazon Time)',
  },
  {
    value: 'America/Puerto_Rico',
    label: 'America/Puerto_Rico (Atlantic Standard Time)',
  },
  {
    value: 'America/Rio_Branco',
    label: 'America/Rio_Branco (Amazon Time)',
  },
  {
    value: 'America/Santiago',
    label: 'America/Santiago (Chile Time)',
  },
  {
    value: 'America/Santo_Domingo',
    label: 'America/Santo_Domingo (Atlantic Standard Time)',
  },
  {
    value: 'America/St_Barthelemy',
    label: 'America/St_Barthelemy (Atlantic Standard Time)',
  },
  {
    value: 'America/St_Kitts',
    label: 'America/St_Kitts (Atlantic Standard Time)',
  },
  {
    value: 'America/St_Lucia',
    label: 'America/St_Lucia (Atlantic Standard Time)',
  },
  {
    value: 'America/St_Thomas',
    label: 'America/St_Thomas (Atlantic Standard Time)',
  },
  {
    value: 'America/St_Vincent',
    label: 'America/St_Vincent (Atlantic Standard Time)',
  },
  {
    value: 'America/Thule',
    label: 'America/Thule (Atlantic Standard Time)',
  },
  {
    value: 'America/Tortola',
    label: 'America/Tortola (Atlantic Standard Time)',
  },
  {
    value: 'Antarctica/Palmer',
    label: 'Antarctica/Palmer (Chile Time)',
  },
  {
    value: 'Atlantic/Bermuda',
    label: 'Atlantic/Bermuda (Atlantic Standard Time)',
  },
  {
    value: 'Atlantic/Stanley',
    label: 'Atlantic/Stanley (Falkland Is. Time)',
  },
  {
    value: 'Brazil/Acre',
    label: 'Brazil/Acre (Amazon Time)',
  },
  {
    value: 'Brazil/West',
    label: 'Brazil/West (Amazon Time)',
  },
  {
    value: 'Canada/Atlantic',
    label: 'Canada/Atlantic (Atlantic Standard Time)',
  },
  {
    value: 'Chile/Continental',
    label: 'Chile/Continental (Chile Time)',
  },
  {
    value: 'America/St_Johns',
    label: 'GAmerica/St_Johns (Newfoundland Standard Time)',
  },
  {
    value: 'Canada/Newfoundland',
    label: 'GCanada/Newfoundland (Newfoundland Standard Time)',
  },
  {
    value: 'America/Araguaina',
    label: 'America/Araguaina (Brasilia Time)',
  },
  {
    value: 'America/Bahia',
    label: 'America/Bahia (Brasilia Time)',
  },
  {
    value: 'America/Belem',
    label: 'America/Belem (Brasilia Time)',
  },
  {
    value: 'America/Buenos_Aires',
    label: 'America/Buenos_Aires (Argentine Time)',
  },
  {
    value: 'America/Catamarca',
    label: 'America/Catamarca (Argentine Time)',
  },
  {
    value: 'America/Cayenne',
    label: 'America/Cayenne (French Guiana Time)',
  },
  {
    value: 'America/Cordoba',
    label: 'America/Cordoba (Argentine Time)',
  },
  {
    value: 'America/Fortaleza',
    label: 'America/Fortaleza (Brasilia Time)',
  },
  {
    value: 'America/Jujuy',
    label: 'America/Jujuy (Argentine Time)',
  },
  {
    value: 'America/Maceio',
    label: 'America/Maceio (Brasilia Time)',
  },
  {
    value: 'America/Mendoza',
    label: 'America/Mendoza (Argentine Time)',
  },
  {
    value: 'America/Miquelon',
    label: 'America/Miquelon (Pierre &amp; Miquelon Standard Time)',
  },
  {
    value: 'America/Montevideo',
    label: 'America/Montevideo (Uruguay Time)',
  },
  {
    value: 'America/Paramaribo',
    label: 'America/Paramaribo (Suriname Time)',
  },
  {
    value: 'America/Recife',
    label: 'America/Recife (Brasilia Time)',
  },
  {
    value: 'America/Santarem',
    label: 'America/Santarem (Brasilia Time)',
  },
  {
    value: 'America/Sao_Paulo',
    label: 'America/Sao_Paulo (Brasilia Time)',
  },
  {
    value: 'Antarctica/Rothera',
    label: 'Antarctica/Rothera (Rothera Time)',
  },
  {
    value: 'Brazil/East',
    label: 'Brazil/East (Brasilia Time)',
  },
  {
    value: 'America/Noronha',
    label: 'America/Noronha (Fernando de Noronha Time)',
  },
  {
    value: 'Atlantic/South_Georgia',
    label: 'Atlantic/South_Georgia (South Georgia Standard Time)',
  },
  {
    value: 'Brazil/DeNoronha',
    label: 'Brazil/DeNoronha (Fernando de Noronha Time)',
  },
  {
    value: 'America/Scoresbysund',
    label: 'America/Scoresbysund (Eastern Greenland Time)',
  },
  {
    value: 'Atlantic/Azores',
    label: 'Atlantic/Azores (Azores Time)',
  },
  {
    value: 'Atlantic/Cape_Verde',
    label: 'Atlantic/Cape_Verde (Cape Verde Time)',
  },
  {
    value: 'Africa/Abidjan',
    label: 'Africa/Abidjan (Greenwich Mean Time)',
  },
  {
    value: 'Africa/Accra',
    label: 'Africa/Accra (Ghana Mean Time)',
  },
  {
    value: 'Africa/Bamako',
    label: 'Africa/Bamako (Greenwich Mean Time)',
  },
  {
    value: 'Africa/Banjul',
    label: 'Africa/Banjul (Greenwich Mean Time)',
  },
  {
    value: 'Africa/Bissau',
    label: 'Africa/Bissau (Greenwich Mean Time)',
  },
  {
    value: 'Africa/Casablanca',
    label: 'Africa/Casablanca (Western European Time)',
  },
  {
    value: 'Africa/Conakry',
    label: 'Africa/Conakry (Greenwich Mean Time)',
  },
  {
    value: 'Africa/Dakar',
    label: 'Africa/Dakar (Greenwich Mean Time)',
  },
  {
    value: 'Africa/El_Aaiun',
    label: 'Africa/El_Aaiun (Western European Time)',
  },
  {
    value: 'Africa/Freetown',
    label: 'Africa/Freetown (Greenwich Mean Time)',
  },
  {
    value: 'Africa/Lome',
    label: 'Africa/Lome (Greenwich Mean Time)',
  },
  {
    value: 'Africa/Monrovia',
    label: 'Africa/Monrovia (Greenwich Mean Time)',
  },
  {
    value: 'Africa/Nouakchott',
    label: 'Africa/Nouakchott (Greenwich Mean Time)',
  },
  {
    value: 'Africa/Ouagadougou',
    label: 'Africa/Ouagadougou (Greenwich Mean Time)',
  },
  {
    value: 'Africa/Sao_Tome',
    label: 'Africa/Sao_Tome (Greenwich Mean Time)',
  },
  {
    value: 'Africa/Timbuktu',
    label: 'Africa/Timbuktu (Greenwich Mean Time)',
  },
  {
    value: 'America/Danmarkshavn',
    label: 'America/Danmarkshavn (Greenwich Mean Time)',
  },
  {
    value: 'Atlantic/Canary',
    label: 'Atlantic/Canary (Western European Time)',
  },
  {
    value: 'Atlantic/Faeroe',
    label: 'Atlantic/Faeroe (Western European Time)',
  },
  {
    value: 'Atlantic/Faroe',
    label: 'Atlantic/Faroe (Western European Time)',
  },
  {
    value: 'Atlantic/Madeira',
    label: 'Atlantic/Madeira (Western European Time)',
  },
  {
    value: 'Atlantic/Reykjavik',
    label: 'Atlantic/Reykjavik (Greenwich Mean Time)',
  },
  {
    value: 'Atlantic/St_Helena',
    label: 'Atlantic/St_Helena (Greenwich Mean Time)',
  },
  {
    value: 'Europe/Belfast',
    label: 'Europe/Belfast (Greenwich Mean Time)',
  },
  {
    value: 'Europe/Dublin',
    label: 'Europe/Dublin (Greenwich Mean Time)',
  },
  {
    value: 'Europe/Guernsey',
    label: 'Europe/Guernsey (Greenwich Mean Time)',
  },
  {
    value: 'Europe/Isle_of_Man',
    label: 'Europe/Isle_of_Man (Greenwich Mean Time)',
  },
  {
    value: 'Europe/Jersey',
    label: 'Europe/Jersey (Greenwich Mean Time)',
  },
  {
    value: 'Europe/Lisbon',
    label: 'Europe/Lisbon (Western European Time)',
  },
  {
    value: 'Europe/London',
    label: 'Europe/London (Greenwich Mean Time)',
  },
  {
    value: 'Africa/Algiers',
    label: 'Africa/Algiers (Central European Time)',
  },
  {
    value: 'Africa/Bangui',
    label: 'Africa/Bangui (Western African Time)',
  },
  {
    value: 'Africa/Brazzaville',
    label: 'Africa/Brazzaville (Western African Time)',
  },
  {
    value: 'Africa/Ceuta',
    label: 'Africa/Ceuta (Central European Time)',
  },
  {
    value: 'Africa/Douala',
    label: 'Africa/Douala (Western African Time)',
  },
  {
    value: 'Africa/Kinshasa',
    label: 'Africa/Kinshasa (Western African Time)',
  },
  {
    value: 'Africa/Lagos',
    label: 'Africa/Lagos (Western African Time)',
  },
  {
    value: 'Africa/Libreville',
    label: 'Africa/Libreville (Western African Time)',
  },
  {
    value: 'Africa/Luanda',
    label: 'Africa/Luanda (Western African Time)',
  },
  {
    value: 'Africa/Malabo',
    label: 'Africa/Malabo (Western African Time)',
  },
  {
    value: 'Africa/Ndjamena',
    label: 'Africa/Ndjamena (Western African Time)',
  },
  {
    value: 'Africa/Niamey',
    label: 'Africa/Niamey (Western African Time)',
  },
  {
    value: 'Africa/Porto-Novo',
    label: 'Africa/Porto-Novo (Western African Time)',
  },
  {
    value: 'Africa/Tunis',
    label: 'Africa/Tunis (Central European Time)',
  },
  {
    value: 'Africa/Windhoek',
    label: 'Africa/Windhoek (Western African Time)',
  },
  {
    value: 'Arctic/Longyearbyen',
    label: 'Arctic/Longyearbyen (Central European Time)',
  },
  {
    value: 'Atlantic/Jan_Mayen',
    label: 'Atlantic/Jan_Mayen (Central European Time)',
  },
  {
    value: 'Europe/Amsterdam',
    label: 'Europe/Amsterdam (Central European Time)',
  },
  {
    value: 'Europe/Andorra',
    label: 'Europe/Andorra (Central European Time)',
  },
  {
    value: 'Europe/Belgrade',
    label: 'Europe/Belgrade (Central European Time)',
  },
  {
    value: 'Europe/Berlin',
    label: 'Europe/Berlin (Central European Time)',
  },
  {
    value: 'Europe/Bratislava',
    label: 'Europe/Bratislava (Central European Time)',
  },
  {
    value: 'Europe/Brussels',
    label: 'Europe/Brussels (Central European Time)',
  },
  {
    value: 'Europe/Budapest',
    label: 'Europe/Budapest (Central European Time)',
  },
  {
    value: 'Europe/Copenhagen',
    label: 'Europe/Copenhagen (Central European Time)',
  },
  {
    value: 'Europe/Gibraltar',
    label: 'Europe/Gibraltar (Central European Time)',
  },
  {
    value: 'Europe/Ljubljana',
    label: 'Europe/Ljubljana (Central European Time)',
  },
  {
    value: 'Europe/Luxembourg',
    label: 'Europe/Luxembourg (Central European Time)',
  },
  {
    value: 'Europe/Madrid',
    label: 'Europe/Madrid (Central European Time)',
  },
  {
    value: 'Europe/Malta',
    label: 'Europe/Malta (Central European Time)',
  },
  {
    value: 'Europe/Monaco',
    label: 'Europe/Monaco (Central European Time)',
  },
  {
    value: 'Europe/Oslo',
    label: 'Europe/Oslo (Central European Time)',
  },
  {
    value: 'Europe/Paris',
    label: 'Europe/Paris (Central European Time)',
  },
  {
    value: 'Europe/Podgorica',
    label: 'Europe/Podgorica (Central European Time)',
  },
  {
    value: 'Europe/Prague',
    label: 'Europe/Prague (Central European Time)',
  },
  {
    value: 'Europe/Rome',
    label: 'Europe/Rome (Central European Time)',
  },
  {
    value: 'Europe/San_Marino',
    label: 'Europe/San_Marino (Central European Time)',
  },
  {
    value: 'Europe/Sarajevo',
    label: 'Europe/Sarajevo (Central European Time)',
  },
  {
    value: 'Europe/Skopje',
    label: 'Europe/Skopje (Central European Time)',
  },
  {
    value: 'Europe/Stockholm',
    label: 'Europe/Stockholm (Central European Time)',
  },
  {
    value: 'Europe/Tirane',
    label: 'Europe/Tirane (Central European Time)',
  },
  {
    value: 'Europe/Vaduz',
    label: 'Europe/Vaduz (Central European Time)',
  },
  {
    value: 'Europe/Vatican',
    label: 'Europe/Vatican (Central European Time)',
  },
  {
    value: 'Europe/Vienna',
    label: 'Europe/Vienna (Central European Time)',
  },
  {
    value: 'Europe/Warsaw',
    label: 'Europe/Warsaw (Central European Time)',
  },
  {
    value: 'Europe/Zagreb',
    label: 'Europe/Zagreb (Central European Time)',
  },
  {
    value: 'Europe/Zurich',
    label: 'Europe/Zurich (Central European Time)',
  },
  {
    value: 'Africa/Blantyre',
    label: 'Africa/Blantyre (Central African Time)',
  },
  {
    value: 'Africa/Bujumbura',
    label: 'Africa/Bujumbura (Central African Time)',
  },
  {
    value: 'Africa/Cairo',
    label: 'Africa/Cairo (Eastern European Time)',
  },
  {
    value: 'Africa/Gaborone',
    label: 'Africa/Gaborone (Central African Time)',
  },
  {
    value: 'Africa/Harare',
    label: 'Africa/Harare (Central African Time)',
  },
  {
    value: 'Africa/Johannesburg',
    label: 'Africa/Johannesburg (South Africa Standard Time)',
  },
  {
    value: 'Africa/Kigali',
    label: 'Africa/Kigali (Central African Time)',
  },
  {
    value: 'Africa/Lubumbashi',
    label: 'Africa/Lubumbashi (Central African Time)',
  },
  {
    value: 'Africa/Lusaka',
    label: 'Africa/Lusaka (Central African Time)',
  },
  {
    value: 'Africa/Maputo',
    label: 'Africa/Maputo (Central African Time)',
  },
  {
    value: 'Africa/Maseru',
    label: 'Africa/Maseru (South Africa Standard Time)',
  },
  {
    value: 'Africa/Mbabane',
    label: 'Africa/Mbabane (South Africa Standard Time)',
  },
  {
    value: 'Africa/Tripoli',
    label: 'Africa/Tripoli (Eastern European Time)',
  },
  {
    value: 'Asia/Amman',
    label: 'Asia/Amman (Eastern European Time)',
  },
  {
    value: 'Asia/Beirut',
    label: 'Asia/Beirut (Eastern European Time)',
  },
  {
    value: 'Asia/Damascus',
    label: 'Asia/Damascus (Eastern European Time)',
  },
  {
    value: 'Asia/Gaza',
    label: 'Asia/Gaza (Eastern European Time)',
  },
  {
    value: 'Asia/Istanbul',
    label: 'Asia/Istanbul (Eastern European Time)',
  },
  {
    value: 'Asia/Jerusalem',
    label: 'Asia/Jerusalem (Israel Standard Time)',
  },
  {
    value: 'Asia/Nicosia',
    label: 'Asia/Nicosia (Eastern European Time)',
  },
  {
    value: 'Asia/Tel_Aviv',
    label: 'Asia/Tel_Aviv (Israel Standard Time)',
  },
  {
    value: 'Europe/Athens',
    label: 'Europe/Athens (Eastern European Time)',
  },
  {
    value: 'Europe/Bucharest',
    label: 'Europe/Bucharest (Eastern European Time)',
  },
  {
    value: 'Europe/Chisinau',
    label: 'Europe/Chisinau (Eastern European Time)',
  },
  {
    value: 'Europe/Helsinki',
    label: 'Europe/Helsinki (Eastern European Time)',
  },
  {
    value: 'Europe/Istanbul',
    label: 'Europe/Istanbul (Eastern European Time)',
  },
  {
    value: 'Europe/Kaliningrad',
    label: 'Europe/Kaliningrad (Eastern European Time)',
  },
  {
    value: 'Europe/Kiev',
    label: 'Europe/Kiev (Eastern European Time)',
  },
  {
    value: 'Europe/Mariehamn',
    label: 'Europe/Mariehamn (Eastern European Time)',
  },
  {
    value: 'Europe/Minsk',
    label: 'Europe/Minsk (Eastern European Time)',
  },
  {
    value: 'Europe/Nicosia',
    label: 'Europe/Nicosia (Eastern European Time)',
  },
  {
    value: 'Europe/Riga',
    label: 'Europe/Riga (Eastern European Time)',
  },
  {
    value: 'Europe/Simferopol',
    label: 'Europe/Simferopol (Eastern European Time)',
  },
  {
    value: 'Europe/Sofia',
    label: 'Europe/Sofia (Eastern European Time)',
  },
  {
    value: 'Europe/Tallinn',
    label: 'Europe/Tallinn (Eastern European Time)',
  },
  {
    value: 'Europe/Tiraspol',
    label: 'Europe/Tiraspol (Eastern European Time)',
  },
  {
    value: 'Europe/Uzhgorod',
    label: 'Europe/Uzhgorod (Eastern European Time)',
  },
  {
    value: 'Europe/Vilnius',
    label: 'Europe/Vilnius (Eastern European Time)',
  },
  {
    value: 'Europe/Zaporozhye',
    label: 'Europe/Zaporozhye (Eastern European Time)',
  },
  {
    value: 'Africa/Addis_Ababa',
    label: 'Africa/Addis_Ababa (Eastern African Time)',
  },
  {
    value: 'Africa/Asmara',
    label: 'Africa/Asmara (Eastern African Time)',
  },
  {
    value: 'Africa/Asmera',
    label: 'Africa/Asmera (Eastern African Time)',
  },
  {
    value: 'Africa/Dar_es_Salaam',
    label: 'Africa/Dar_es_Salaam (Eastern African Time)',
  },
  {
    value: 'Africa/Djibouti',
    label: 'Africa/Djibouti (Eastern African Time)',
  },
  {
    value: 'Africa/Kampala',
    label: 'Africa/Kampala (Eastern African Time)',
  },
  {
    value: 'Africa/Khartoum',
    label: 'Africa/Khartoum (Eastern African Time)',
  },
  {
    value: 'Africa/Mogadishu',
    label: 'Africa/Mogadishu (Eastern African Time)',
  },
  {
    value: 'Africa/Nairobi',
    label: 'Africa/Nairobi (Eastern African Time)',
  },
  {
    value: 'Antarctica/Syowa',
    label: 'Antarctica/Syowa (Syowa Time)',
  },
  {
    value: 'Asia/Aden',
    label: 'Asia/Aden (Arabia Standard Time)',
  },
  {
    value: 'Asia/Baghdad',
    label: 'Asia/Baghdad (Arabia Standard Time)',
  },
  {
    value: 'Asia/Bahrain',
    label: 'Asia/Bahrain (Arabia Standard Time)',
  },
  {
    value: 'Asia/Kuwait',
    label: 'Asia/Kuwait (Arabia Standard Time)',
  },
  {
    value: 'Asia/Qatar',
    label: 'Asia/Qatar (Arabia Standard Time)',
  },
  {
    value: 'Asia/Riyadh',
    label: 'Asia/Riyadh (Arabia Standard Time)',
  },
  {
    value: 'Europe/Moscow',
    label: 'Europe/Moscow (Moscow Standard Time)',
  },
  {
    value: 'Europe/Volgograd',
    label: 'Europe/Volgograd (Volgograd Time)',
  },
  {
    value: 'Indian/Antananarivo',
    label: 'Indian/Antananarivo (Eastern African Time)',
  },
  {
    value: 'Indian/Comoro',
    label: 'Indian/Comoro (Eastern African Time)',
  },
  {
    value: 'Indian/Mayotte',
    label: 'Indian/Mayotte (Eastern African Time)',
  },
  {
    value: 'Asia/Tehran',
    label: 'Asia/Tehran (Iran Standard Time)',
  },
  {
    value: 'Asia/Baku',
    label: 'Asia/Baku (Azerbaijan Time)',
  },
  {
    value: 'Asia/Dubai',
    label: 'Asia/Dubai (Gulf Standard Time)',
  },
  {
    value: 'Asia/Muscat',
    label: 'Asia/Muscat (Gulf Standard Time)',
  },
  {
    value: 'Asia/Tbilisi',
    label: 'Asia/Tbilisi (Georgia Time)',
  },
  {
    value: 'Asia/Yerevan',
    label: 'Asia/Yerevan (Armenia Time)',
  },
  {
    value: 'Europe/Samara',
    label: 'Europe/Samara (Samara Time)',
  },
  {
    value: 'Indian/Mahe',
    label: 'Indian/Mahe (Seychelles Time)',
  },
  {
    value: 'Indian/Mauritius',
    label: 'Indian/Mauritius (Mauritius Time)',
  },
  {
    value: 'Indian/Reunion',
    label: 'Indian/Reunion (Reunion Time)',
  },
  {
    value: 'Asia/Kabul',
    label: 'Asia/Kabul (Afghanistan Time)',
  },
  {
    value: 'Asia/Aqtau',
    label: 'Asia/Aqtau (Aqtau Time)',
  },
  {
    value: 'Asia/Aqtobe',
    label: 'Asia/Aqtobe (Aqtobe Time)',
  },
  {
    value: 'Asia/Ashgabat',
    label: 'Asia/Ashgabat (Turkmenistan Time)',
  },
  {
    value: 'Asia/Dushanbe',
    label: 'Asia/Dushanbe (Tajikistan Time)',
  },
  {
    value: 'Asia/Karachi',
    label: 'Asia/Karachi (Pakistan Time)',
  },
  {
    value: 'Asia/Oral',
    label: 'Asia/Oral (Oral Time)',
  },
  {
    value: 'Asia/Samarkand',
    label: 'Asia/Samarkand (Uzbekistan Time)',
  },
  {
    value: 'Asia/Tashkent',
    label: 'Asia/Tashkent (Uzbekistan Time)',
  },
  {
    value: 'Asia/Yekaterinburg',
    label: 'Asia/Yekaterinburg (Yekaterinburg Time)',
  },
  {
    value: 'Asia/Colombo',
    label: 'Asia/Colombo (India Standard Time)',
  },
  {
    value: 'Asia/Kolkata',
    label: 'Asia/Chennai, Kolkata, Mumbai, New Delhi (India Standard Time)',
  },
  {
    value: 'Asia/Katmandu',
    label: 'Asia/Katmandu (Nepal Time)',
  },
  {
    value: 'Antarctica/Mawson',
    label: 'Antarctica/Mawson (Mawson Time)',
  },
  {
    value: 'Antarctica/Vostok',
    label: 'Antarctica/Vostok (Vostok Time)',
  },
  {
    value: 'Asia/Almaty',
    label: 'Asia/Almaty (Alma-Ata Time)',
  },
  {
    value: 'Asia/Bishkek',
    label: 'Asia/Bishkek (Kirgizstan Time)',
  },
  {
    value: 'Asia/Dhaka',
    label: 'Asia/Dhaka (Bangladesh Time)',
  },
  {
    value: 'Asia/Novosibirsk',
    label: 'Asia/Novosibirsk (Novosibirsk Time)',
  },
  {
    value: 'Asia/Omsk',
    label: 'Asia/Omsk (Omsk Time)',
  },
  {
    value: 'Asia/Qyzylorda',
    label: 'Asia/Qyzylorda (Qyzylorda Time)',
  },
  {
    value: 'Asia/Thimphu',
    label: 'Asia/Thimphu (Bhutan Time)',
  },
  {
    value: 'Asia/Rangoon',
    label: 'Asia/Rangoon (Myanmar Time)',
  },
  {
    value: 'Asia/Bangkok',
    label: 'Asia/Bangkok (Indochina Time)',
  },
  {
    value: 'Asia/Ho_Chi_Minh',
    label: 'Asia/Ho_Chi_Minh (Indochina Time)',
  },
  {
    value: 'Asia/Hovd',
    label: 'Asia/Hovd (Hovd Time)',
  },
  {
    value: 'Asia/Jakarta',
    label: 'Asia/Jakarta (West Indonesia Time)',
  },
  {
    value: 'Asia/Krasnoyarsk',
    label: 'Asia/Krasnoyarsk (Krasnoyarsk Time)',
  },
  {
    value: 'Asia/Phnom_Penh',
    label: 'Asia/Phnom_Penh (Indochina Time)',
  },
  {
    value: 'Asia/Pontianak',
    label: 'Asia/Pontianak (West Indonesia Time)',
  },
  {
    value: 'Asia/Vientiane',
    label: 'Asia/Vientiane (Indochina Time)',
  },
  {
    value: 'Antarctica/Casey',
    label: 'Antarctica/Casey (Western Standard Time (Australia))',
  },
  {
    value: 'Asia/Brunei',
    label: 'Asia/Brunei (Brunei Time)',
  },
  {
    value: 'Asia/Choibalsan',
    label: 'Asia/Choibalsan (Choibalsan Time)',
  },
  {
    value: 'Asia/Hong_Kong',
    label: 'Asia/Hong_Kong (Hong Kong Time)',
  },
  {
    value: 'Asia/Irkutsk',
    label: 'Asia/Irkutsk (Irkutsk Time)',
  },
  {
    value: 'Asia/Kuala_Lumpur',
    label: 'Asia/Kuala_Lumpur (Malaysia Time)',
  },
  {
    value: 'Asia/Kuching',
    label: 'Asia/Kuching (Malaysia Time)',
  },
  {
    value: 'Asia/Macau',
    label: 'Asia/Macau (China Standard Time)',
  },
  {
    value: 'Asia/Makassar',
    label: 'Asia/Makassar (Central Indonesia Time)',
  },
  {
    value: 'Asia/Manila',
    label: 'Asia/Manila (Philippines Time)',
  },
  {
    value: 'Asia/Shanghai',
    label: 'Asia/Shanghai (China Standard Time)',
  },
  {
    value: 'Asia/Singapore',
    label: 'Asia/Singapore (Singapore Time)',
  },
  {
    value: 'Asia/Taipei',
    label: 'Asia/Taipei (China Standard Time)',
  },
  {
    value: 'Asia/Ulaanbaatar',
    label: 'Asia/Ulaanbaatar (Ulaanbaatar Time)',
  },
  {
    value: 'Asia/Urumqi',
    label: 'Asia/Urumqi (China Standard Time)',
  },
  {
    value: 'Australia/Perth',
    label: 'Australia/Perth (Western Standard Time (Australia))',
  },
  {
    value: 'Australia/West',
    label: 'Australia/West (Western Standard Time (Australia))',
  },
  {
    value: 'Australia/Eucla',
    label: 'Australia/Eucla (Central Western Standard Time (Australia))',
  },
  {
    value: 'Asia/Dili',
    label: 'Asia/Dili (Timor-Leste Time)',
  },
  {
    value: 'Asia/Jayapura',
    label: 'Asia/Jayapura (East Indonesia Time)',
  },
  {
    value: 'Asia/Pyongyang',
    label: 'Asia/Pyongyang (Korea Standard Time)',
  },
  {
    value: 'Asia/Seoul',
    label: 'Asia/Seoul (Korea Standard Time)',
  },
  {
    value: 'Asia/Tokyo',
    label: 'Asia/Tokyo (Japan Standard Time)',
  },
  {
    value: 'Asia/Yakutsk',
    label: 'Asia/Yakutsk (Yakutsk Time)',
  },
  {
    value: 'Australia/Adelaide',
    label: 'Australia/Adelaide (Central Standard Time (South Australia))',
  },
  {
    value: 'Australia/Broken_Hill',
    label:
      'Australia/Broken_Hill (Central Standard Time (South Australia/New South Wales))',
  },
  {
    value: 'Australia/Darwin',
    label: 'Australia/Darwin (Central Standard Time (Northern Territory))',
  },
  {
    value: 'Australia/North',
    label: 'Australia/North (Central Standard Time (Northern Territory))',
  },
  {
    value: 'Australia/South',
    label: 'Australia/South (Central Standard Time (South Australia))',
  },
  {
    value: 'Australia/Yancowinna',
    label:
      'Australia/Yancowinna (Central Standard Time (South Australia/New South Wales))',
  },
  {
    value: 'Antarctica/DumontDUrville',
    label: "Antarctica/DumontDUrville (Dumont-d'Urville Time)",
  },
  {
    value: 'Asia/Sakhalin',
    label: 'Asia/Sakhalin (Sakhalin Time)',
  },
  {
    value: 'Asia/Vladivostok',
    label: 'Asia/Vladivostok (Vladivostok Time)',
  },
  {
    value: 'Australia/ACT',
    label: 'Australia/ACT (Eastern Standard Time (New South Wales))',
  },
  {
    value: 'Australia/Brisbane',
    label: 'Australia/Brisbane (Eastern Standard Time (Queensland))',
  },
  {
    value: 'Australia/Canberra',
    label: 'Australia/Canberra (Eastern Standard Time (New South Wales))',
  },
  {
    value: 'Australia/Currie',
    label: 'Australia/Currie (Eastern Standard Time (New South Wales))',
  },
  {
    value: 'Australia/Hobart',
    label: 'Australia/Hobart (Eastern Standard Time (Tasmania))',
  },
  {
    value: 'Australia/Lindeman',
    label: 'Australia/Lindeman (Eastern Standard Time (Queensland))',
  },
  {
    value: 'Australia/Melbourne',
    label: 'Australia/Melbourne (Eastern Standard Time (Victoria))',
  },
  {
    value: 'Australia/NSW',
    label: 'Australia/NSW (Eastern Standard Time (New South Wales))',
  },
  {
    value: 'Australia/Queensland',
    label: 'Australia/Queensland (Eastern Standard Time (Queensland)',
  },
  {
    value: 'Australia/Sydney',
    label: 'Australia/Sydney (Eastern Standard Time (New South Wales))',
  },
  {
    value: 'Australia/Tasmania',
    label: 'Australia/Tasmania (Eastern Standard Time (Tasmania))',
  },
  {
    value: 'Australia/Victoria',
    label: 'Australia/Victoria (Eastern Standard Time (Victoria))',
  },
  {
    value: 'Australia/LHI',
    label: 'Australia/LHI (Lord Howe Standard Time)',
  },
  {
    value: 'Australia/Lord_Howe',
    label: 'Australia/Lord_Howe (Lord Howe Standard Time)',
  },
  {
    value: 'Asia/Magadan',
    label: 'Asia/Magadan (Magadan Time)',
  },
  {
    value: 'Antarctica/McMurdo',
    label: 'Antarctica/McMurdo (New Zealand Standard Time)',
  },
  {
    value: 'Antarctica/South_Pole',
    label: 'Antarctica/South_Pole (New Zealand Standard Time)',
  },
  {
    value: 'Asia/Anadyr',
    label: 'Asia/Anadyr (Anadyr Time)',
  },
  {
    value: 'Asia/Kamchatka',
    label: 'Asia/Kamchatka (Petropavlovsk-Kamchatski Time)',
  },
  {
    value: 'Pacific/Auckland',
    label: 'Auckland, Wellington (Pacific Standard Time)',
  },
  {
    value: 'Pacific/Fiji',
    label: 'Fiji, Kamchatka, Marshall Is. (Pacific Standard Time)',
  },
  {
    value: 'Pacific/Chatham',
    label: 'Chatham Islands (Pacific Standard Time)',
  },
  {
    value: 'Pacific/Tongatapu',
    label: 'Nukualofa (Pacific Standard Time)',
  },
  {
    value: 'Pacific/Kiritimati',
    label: 'Kiritimati (Pacific Standard Time)',
  },
];
